import {header} from "./modules/header";
import {panelShare} from "./modules/panel-share";
import {optimizedResize, setAppHeight} from './modules/helpers';
import PostFilter from './post-filter';
import CustomDropdown from './modules/sk-custom-dropdown';
import AnchorScroll from './modules/anchor-scroll';
import CommonAccessibility from './modules/accessibility';

document.addEventListener("DOMContentLoaded", function () {
  optimizedResize();
  setAppHeight();
  header().init()
  panelShare().init()
  PostFilter.init();
  CustomDropdown.init();
  AnchorScroll.init();
  CommonAccessibility.init();
})

window.addEventListener('optimizedResize', () => {
  setAppHeight();
});
